import i18n from "../locales/i18n";
import { email_regex } from "./regex";
import { IPRI, IPstnPhoneNumbers } from "../interfaces/Application";
import { contactCommunicationDefaults, nationOptions } from "./options";
import i18next from "i18next";
import axios from "axios";

export * from "./options";

export const params = {
  pagination: { pageNumber: 0, size: 100 },
  sort: { field: "", order: "ASC" },
  filter: {},
  limit: 5,
};

export function onlyNumberKey(event: any) {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
}
export function onlyLetterKey(event: any) {
  if (!/^[a-zA-ZğüşöçİĞÜŞÖÇı]+$/.test(event.key)) {
    event.preventDefault();
  }
}

export function onlyNumberKeyWithComma(event: any) {
  if (!/^[0-9,]*$/.test(event.key)) {
    event.preventDefault();
  }
}

export function onlyEmailKey(event: any) {
  if (email_regex.test(event.key)) {
    event.preventDefault();
  }
}

export function financial(x: any) {
  return Number.parseFloat(Number.parseFloat(x).toFixed(2));
}

export function financialWithComma(x: any) {
  return Number.parseFloat(x).toFixed(2).replace(".", ",");
}

export function buildFormData(formData: FormData, data: any, parentKey?: any) {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey
          ? `${firstLetterUpper(parentKey)}.${firstLetterUpper(key)}`
          : firstLetterUpper(key)
      );
    });
  } else {
    const value = data == null ? "" : data;

    formData.append(parentKey, value);
  }
}

export function firstLetterUpper(letter: string) {
  return letter.charAt(0).toUpperCase() + letter.slice(1);
}

interface Props {
  value?: string | number | boolean;
  label?: string;
}

export function locale(options: Props[], prefix?: any) {
  let formattedOptions: any = [];

  options.forEach((option: Props) => {
    let obj = {
      value: option.value,
      label: i18n.t(`${prefix ?? ""}${option.label}`),
    };
    formattedOptions.push(obj);
  });

  return formattedOptions;
}

export const isExists = (value: any) => {
  let isExists = true;
  switch (value) {
    case null:
      isExists = false;
      break;
    case undefined:
      isExists = false;
      break;
    case "":
      isExists = false;
      break;
    case "undefined":
      isExists = false;
      break;
  }
  return isExists;
};

export const groupBy = (arr: any, key: any) => {
  const initialValue = {};
  return arr.reduce((acc: any, cval: any) => {
    const myAttribute = cval[key];
    acc[myAttribute] = [...(acc[myAttribute] || []), cval];
    return acc;
  }, initialValue);
};

export const nestedHandler = (array: any, id: any) =>
  array
    .filter((element: any) => element.parentId === id)
    .map(({ id, children, ...rest }: any) => ({
      ...rest,
      id,
      children: nestedHandler(array, id),
    }));

function isEmpty(obj: any) {
  if (
    obj === "" ||
    obj === null ||
    JSON.stringify(obj) === "{}" ||
    JSON.stringify(obj) === "[]" ||
    obj === undefined ||
    obj === {}
  ) {
    return true;
  } else {
    return false;
  }
}
export function clean(o: any) {
  if (typeof o !== "object") {
    return o;
  }
  let oKeys = Object.keys(o);
  for (let j = 0; j < oKeys.length; j++) {
    let p = oKeys[j];
    switch (typeof o[p]) {
      case "object":
        if (Array.isArray(o[p])) {
          for (let i = 0; i < o[p].length; i++) {
            o[p][i] = clean(o[p][i]);
            if (isEmpty(o[p][i])) {
              o[p].splice(i, 1);
              i--;
            }
          }
          if (o[p].length === 0) {
            if (Array.isArray(o)) {
              o.splice(parseInt(p), 1);
              j--;
            } else {
              delete o[p];
            }
          }
        } else {
          if (o[p] instanceof Date) break;

          if (isEmpty(o[p])) {
            try {
              delete o[p];
            } catch {
              break;
            }
          } else {
            o[p] = clean(o[p]);
            if (isEmpty(o[p])) delete o[p];
          }
        }
        break;
      default:
        if (isEmpty(o[p])) {
          delete o[p];
        }
        break;
    }
  }
  if (Object.keys(o).length === 0) {
    return;
  }
  return o;
}

export async function fetcher(url: string, method: string, body: any) {
  let data;
  const token = localStorage.getItem("token");
  try {
    const res = await axios({
      method: method,
      url: process.env.REACT_APP_BASE_API + url,
      data: body,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res;
  } catch (err) {
    return err;
  }

  return data;
}

export function getCountryName(value: number) {
  const countryName: any = nationOptions.find(
    (nation) => nation.value === value
  )?.label;

  if (!isExists(countryName)) return null;

  return countryName;
}

export function setAddress(address: any, creatorEmail: any) {
  const customAddress = {
    isDefaultAddress: address.isDefaultAddress,
    name: "Varsayılan Adres",
    detail: address.detail,
    nationalityId: address.isForeign ? 2 : address.nationalityId,
    isForeign: address.isForeign,
    countryName: address.isForeign
      ? address.countryName
      : getCountryName(address.nationalityId),
    ttCityName: address.city.label,
    ttTownName: address.town?.label,
    creatorEmail: creatorEmail,

    addressDetail: {
      postalCode: address?.addressDetail?.postalCode,
      longitude: address?.addressDetail?.longitude,
      latitude: address?.addressDetail?.latitude,
      vsatId: address?.addressDetail?.vsatId,
      uniqueAddressCode: address?.addressDetail?.uniqueAddressCode,
      addressTypeId: address?.addressDetail?.addressTypeId,
      addressLocationId: address.addressDetail?.addressLocationId,
      buildingNumber: address?.addressDetail?.buildingNumber,
      doorNumber: address?.addressDetail?.doorNumber,
      adressNotFound: address?.addressDetail?.adressNotFound,
      autCode: address?.addressDetail?.autCode,
      dealerCode: address?.addressDetail?.dealerCode,
      stationCode: address?.addressDetail?.stationCode,
      licenceCode: address?.addressDetail?.licenceCode,
      idCity: address?.city?.value,
      cityName: address?.city?.label,
      idTown: address?.town?.value,
      townName: address?.town?.label,
      idTowShip: address?.townShip.value,
      towShipName: address?.townShip.label,
      idVillage: address?.village.value,
      villageName: address?.village.label,
      idDistrict: address?.district.value,
      districtName: address?.district.label,
      idStreet: address?.street?.value,
      csbmName: address?.street?.label,
      idBulding: address?.building?.value,
      buldingName: address?.building?.label,
      doorNo: address?.door?.label,
    },
  };

  return clean(customAddress);
}

export function setAddressCustomer(address: any, creatorEmail: any) {
  const customAddress = {
    isDefaultAddress: address.isDefaultAddress,

    name: address.name,
    detail: address.detail,
    nationalityId: address.nationalityId,
    isForeign: address.isForeign,
    countryName: getCountryName(address.nationalityId),
    ttCityName: address.city.label,
    ttTownName: address.town.label,
    ttCityCode: address.city.value,
    ttTownCode: address.town.value,
    creatorEmail: creatorEmail,
    addressDetail: {
      postalCode: address?.addressDetail?.postalCode,
      longitude: address?.addressDetail?.longitude,
      latitude: address?.addressDetail?.latitude,
      vsatId: address?.addressDetail?.vsatId,
      uniqueAddressCode: address?.addressDetail?.uniqueAddressCode,
      addressTypeId: address?.addressDetail?.addressTypeId,
      buildingNumber: address?.addressDetail?.buildingNumber,
      addressLocationId: address.addressLocationId,
      doorNumber: address?.addressDetail?.doorNumber,
      adressNotFound: address?.addressDetail?.adressNotFound,
      autCode: address?.addressDetail?.autCode,
      dealerCode: address?.addressDetail?.dealerCode,
      stationCode: address?.addressDetail?.stationCode,
      licenceCode: address?.addressDetail?.licenceCode,
    },
  };
  return clean(customAddress);
}

export function setDocument(documents: any) {
  const customDocuments = documents.map((document: any) => ({
    documentType: document.documentType,
    file: document.file,
  }));
  return customDocuments;
}

export function setPermission(permissions: any) {
  const customPermissions = permissions.map((permission: any, index: any) => ({
    contactNationalityId: permission.nationality.value,
    contactFatherName: permission.fatherName,
    contactMotherName: permission.motherName,
    contactDocumentNo: permission.documentNo,
    contactCardType: permission.idType.value,
    contactName: permission.name,
    contactSurname: permission.surname,
    contactBirthDate: new Date(permission.birthDate)
      .toISOString()
      .split("T")[0],
    contactGsmNumber: permission.phone,
    contactPhoneNumber: permission.landPhone,
    contactEmail: permission.email,
    contactTRIN: permission.tckn,
    isAuthorizedSignature: permission.isisAuthorizedSignature,
    ContactPhoneNumber: permission.landNumber,
  }));

  return customPermissions;
}

export function convertStringToDate(stringDate: any) {
  if (typeof stringDate === "string") {
    return new Date(stringDate);
  }
  return stringDate;
}

export function changeLabelForDateTimePicker(label: any) {
  return typeof label === "string" && label.slice(-1) !== "Z"
    ? label.concat("Z")
    : label;
}

export function changeLabelForDatePicker(label: any) {
  return typeof label === "string" && label.slice(-1) !== "Z"
    ? label.concat("Z")
    : "";
}

export function setFormattedDate(date: Date) {
  const dateFormat = new Date(date);
  const yyyy = dateFormat.getFullYear();
  let mm: any = dateFormat.getMonth() + 1; // Months start at 0!
  let dd: any = dateFormat.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedDate = dd + "-" + mm + "-" + yyyy;
  return formattedDate;
}

export function generateNestedOptions(array: any[]) {
  const options = (p: any, c: any) => {
    if (p.hasOwnProperty("options")) {
      if (!p.options.includes(c)) {
        p.options.push(c);
      }
    } else {
      p.options = [c];
    }
  };
  array.forEach((item: any, index: number) => {
    const a = array[index];

    array.forEach((category: any, index: number) => {
      if (index > 0) {
        const b = array[index];

        if (a.value === b.parentId) {
          options(a, b);
        } else if (b.value === a.parentId) {
          options(b, a);
        }
      }
    });
  });

  const result = array.filter((x: any) => !x.parentId);
  return result;
}

export const PstnPhoneNumbers = (numbers: any) => {
  const pstnNumbers = numbers.map(
    (number: IPstnPhoneNumbers, index: number) => number.phone
  );

  return pstnNumbers;
};

export const PriNumbers = (pris: any) => {
  const prisData = pris.map(
    (pri: IPRI, index: number) =>
      "[ telefon:" +
      pri.phone +
      ", Pri Bloğu:" +
      pri.block +
      ", Did Sayısı" +
      pri.didcount +
      "]"
  );

  return prisData;
};

export const BriNumbers = (bris: any) => {
  const brisData = bris.map(
    (bri: IPRI, index: number) =>
      "[ telefon:" +
      bri.phone +
      ", Pri Bloğu:" +
      bri.block +
      ", Did Sayısı" +
      bri.didcount +
      "]"
  );

  return brisData;
};

export enum ENV {
  Prod = "prod",
  Dev = "dev",
  Test = "test",
}

function setEditContactCommunicationPermission(
  value: any,
  contactCommunicationPermission: any
) {
  const fields = [
    "debt",
    "invoice",
    "technical",
    "marketingAndGeneralAnnouncement",
    "alarmSmsConfirmation",
  ];

  const permissions = fields.map((item, index) => ({
    id: contactCommunicationPermission
      ? contactCommunicationPermission[index]?.id
      : null,
    notificationId: index + 1,
    approval: value ? (isExists(value[item]) ? value[item] : false) : false,
    contactCommunicationId: contactCommunicationPermission
      ? contactCommunicationPermission[index]?.contactCommunicationId
      : null,
  }));

  return permissions;
}

function setContactCommunicationPermission(value: any) {
  const fields = [
    "debt",
    "invoice",
    "technical",
    "marketingAndGeneralAnnouncement",
    "alarmSmsConfirmation",
  ];

  const permissions = fields.map((item, index) => ({
    notificationId: index + 1,
    approval: value ? (isExists(value[item]) ? value[item] : false) : false,
  }));

  return permissions;
}

export function setContact(contact: any, isExistCustomer: boolean) {
  contact.kvkkMarkApprovalEmail = contact.contactCommunication[0].value;
  contact.kvkkMarkApprovalSms = contact.contactCommunication[1]?.value;
  contact.signitureTypeId = Number(contact.signitureTypeId);
  contact.contactIdentityInformation.genderId = Number(
    contact.contactIdentityInformation.genderId
  );
  contact.dateOfBirth =
    contact.dateOfBirth && !isExistCustomer
      ? setFormattedDateWithLocale(contact.dateOfBirth, "tr")
      : contact.dateOfBirth;

  // contact.nationalityId = isRealCustomer
  //   ? contact.nationalityId
  //   : null;
  const customcontactCommunication: any = [];
  contact.contactCommunication.forEach((item: any) => {
    if (isExists(item.value)) {
      const obj = {
        id: item.id,
        value: item.value,
        description: item.description,
        communicationTypeId: item.communicationTypeId,
        contactCommunicationPermission: setContactCommunicationPermission(
          item.contactCommunicationPermission
        ),
      };

      customcontactCommunication.push(obj);
    }
  });
  const customContact = {
    ...contact,
    contactIdentityInformation: contact.isAuthorizedPerson
      ? contact.contactIdentityInformation
      : null,
    contactCommunication: customcontactCommunication,
  };

  return clean(customContact);
}

export function setEditContact(contact: any, contactCommunication: any) {
  const customcontactCommunication: any = [];

  contact.contactCommunication.forEach((item: any, index: any) => {
    if (item.value) {
      const obj = {
        id: item?.id,
        value: item.value,
        description: item.description,
        communicationTypeId: item.communicationTypeId,
        contactCommunicationPermission: setEditContactCommunicationPermission(
          item.contactCommunicationPermission,
          contactCommunication[index]?.contactCommunicationPermission
        ),
      };
      customcontactCommunication.push(obj);
    }
  });

  const customContact = {
    ...contact,
    contactIdentityInformation: contact.isAuthorizedPerson
      ? contact.contactIdentityInformation
      : null,
    contactCommunication: customcontactCommunication,
  };
  return customContact;
}
export function setEditAddress(address: any) {
  const values = {
    id: address.id,
    isDefaultAddress: address.isDefaultAddress,
    name: "Varsayılan Adres",
    detail: address.detail,
    addressDetail: {
      id: address.addressDetail.id,
      postalCode: address.addressDetail.postalCode,
      longitude: address.addressDetail.longitude,
      latitude: address.addressDetail.latitude,
      vsatId: address.addressDetail.vsatId,
      uniqueAddressCode: address.addressDetail.uniqueAddressCode,
      addressId: address.id,
      addressLocationId: address.addressDetail.addressLocationId,
      addressTypeId: address.addressDetail.addressTypeId,
      merlinId: address.addressDetail.merlinId,
    },
    customerId: address.customerId,
    nationalityId: address.isForeign ? 2 : address.nationalityId,
    isForeign: address.isForeign,
    creatorEmail: address.creatorEmail,
  };
  return values;
}

export function getContactCommunicationPermission(permissions: any) {
  let obj = {
    debt: false,
    invoice: false,
    technical: false,
    marketingAndGeneralAnnouncement: false,
    alarmSmsConfirmation: false,
  };
  permissions.forEach((permission: any) => {
    if (permission.notificationId === 1) {
      obj.debt = permission.approval;
    }
    if (permission.notificationId === 2) {
      obj.invoice = permission.approval;
    }
    if (permission.notificationId === 3) {
      obj.technical = permission.approval;
    }
    if (permission.notificationId === 4) {
      obj.marketingAndGeneralAnnouncement = permission.approval;
    }
    if (permission.notificationId === 5) {
      obj.alarmSmsConfirmation = permission.approval;
    }
  });
  return obj;
}

export function setContactCommunication(contacts: any, contactId: any) {
  let arr = [];
  for (let i = 0; i < contactCommunicationDefaults.length; i++) {
    const e = contactCommunicationDefaults[i];
    if (
      contacts?.find(
        (f: any) => f.communicationTypeId === e.communicationTypeId
      )
    ) {
      let item = contacts?.find(
        (f: any) => f.communicationTypeId === e.communicationTypeId
      );
      arr.push({
        communicationTypeId: item.communicationTypeId,
        contactCommunicationPermission: getContactCommunicationPermission(
          item.contactCommunicationPermission
        ),
        contactId: item.contactId,
        description: item.description,
        id: item.id,
        value: item.value,
      });
    } else {
      arr.push({
        communicationTypeId: e.communicationTypeId,
        contactCommunicationPermission: {
          debt: false,
          invoice: false,
          technical: false,
          marketingAndGeneralAnnouncement: false,
          alarmSmsConfirmation: false,
        },
        contactId: contactId,
        description: e.description,
        id: null,
        value: e.value,
      });
    }
  }
  return arr;
  // const customContacts = contacts.map((item: any) => ({
  //   communicationTypeId: item.communicationTypeId,
  //   contactCommunicationPermission: getContactCommunicationPermission(
  //     item.contactCommunicationPermission
  //   ),
  //   contactId: item.contactId,
  //   description: item.description,
  //   id: item.id,
  //   value: item.value,
  // }));
  // return customContacts;
}

export function setCustomerTags(tags: any) {
  let customTags: any = [];
  tags.forEach((tag: any) => {
    const obj = {
      tagId: tag.value,
    };
    customTags.push(obj);
  });
  return customTags;
}

export const checkFileSize = (file: any) => {
  return file.size !== 0;
};

export const changeFileName = (fileName: string) => {
  let customFileName = fileName
    .replaceAll("+", "_")
    .replaceAll(" ", "_")
    .replaceAll("__", "_");

  if (customFileName.startsWith("_")) customFileName.replace("_", "");

  const fileExtStartIndex = customFileName.lastIndexOf(".");

  if (customFileName[fileExtStartIndex - 1] === "_") {
    let splitedFileName = customFileName.split("");
    splitedFileName[fileExtStartIndex - 1] = "";
    customFileName = splitedFileName.join("");
  }

  return customFileName;
};

export function calculateTotalAmount(values: any) {
  const totalAmount = values
    .map((item: any) => item.priceWithTax)
    .reduce((prev: number, curr: number) => prev + curr, 0);
  return financial(totalAmount);
}

export function calculateTotalKdv(values: any) {
  const totalKdvAmount = values
    .map((item: any) => item.kdvAmount ?? 0)
    .reduce((prev: number, curr: number) => prev + curr, 0);
  return isNaN(totalKdvAmount) ? 0 : financial(totalKdvAmount);
}

export function calculateTotalOtherTax(values: any) {
  const totalOtherTaxAmount = values
    .map((item: any) => parseFloat(item.otherTaxes?.split(" = ")[1] ?? 0))
    .reduce((prev: number, curr: number) => prev + curr, 0);
  return isNaN(totalOtherTaxAmount) ? 0 : financial(totalOtherTaxAmount);
}

export function calculateTotalPrice(values: any) {
  const totalPrice = values
    .map((item: any) => item.calculatedVariantPrice)
    .reduce((prev: number, curr: number) => prev + curr, 0);
  return financial(totalPrice);
}
export function formatDate(inputDate: Date) {
  if (!inputDate) return "";
  let date, month, year;

  date = inputDate.getDate();
  month = inputDate.getMonth() + 1;
  year = inputDate.getFullYear();

  date = date.toString().padStart(2, "0");

  month = month.toString().padStart(2, "0");

  return `${date}/${month}/${year}`;
}
export function setFormatDate(date: Date, locale?: string) {
  const yyyy = date.getFullYear();
  let mm: any = date.getMonth() + 1; // Months start at 0!
  let dd: any = date.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  if (locale) return yyyy + "-" + mm + "-" + dd;
  return mm + "-" + dd + "-" + yyyy;
}

export function setFormattedDateWithLocale(date: Date, locale?: string) {
  const dateFormat = new Date(date);
  const yyyy = dateFormat.getFullYear();
  let mm: any = dateFormat.getMonth() + 1; // Months start at 0!
  let dd: any = dateFormat.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  if (locale) return yyyy + "-" + mm + "-" + dd;
  return dd + "-" + mm + "-" + yyyy;
}
